import React from 'react';
import EazyLogo from './EazyLogo';

export default function CookiePolicy() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a1e', color: 'rgba(255,255,255,0.85)', fontFamily: "'Inter', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 760, margin: '0 auto', padding: '60px 24px 80px' }}>

        <div style={{ marginBottom: 48 }}>
          <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, textDecoration: 'none', marginBottom: 40 }}>
            <EazyLogo size="sm" theme="dark" />
          </a>
          <h1 style={{ fontSize: 32, fontWeight: 700, color: 'white', margin: '0 0 8px' }}>Cookie Policy</h1>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', margin: 0 }}>Last updated: May 2026</p>
        </div>

        <Section title="1. What Are Cookies">
          <p>Cookies are small text files stored on your device by a website. They are commonly used to keep users logged in, remember preferences, and collect analytics data.</p>
          <p>eazyproject does <strong>not</strong> use traditional HTTP cookies for tracking or advertising purposes.</p>
        </Section>

        <Section title="2. What We Use Instead">
          <p>Our platform relies exclusively on <strong>localStorage</strong> — a browser storage mechanism that keeps data locally on your device and is never transmitted to third parties. We use it for the following purposes:</p>
          <ul>
            <li><strong>Authentication token:</strong> a secure JWT token that keeps you logged in during your session. It expires automatically after 8 hours.</li>
            <li><strong>User preferences:</strong> your selected language and display settings.</li>
            <li><strong>Session state:</strong> your last selected project and module, so the app remembers where you left off when you reload the page.</li>
          </ul>
          <p>This data is stored only on your device and is cleared when you log out.</p>
        </Section>

        <Section title="3. Third-Party Cookies">
          <p>eazyproject does not load any third-party analytics, advertising, or tracking scripts. We do not use Google Analytics, Facebook Pixel, Hotjar, or similar tools.</p>
          <p>Our payment provider, Stripe, may set its own cookies during the checkout process. These are governed by <a href="https://stripe.com/privacy" target="_blank" rel="noreferrer" style={{ color: '#818cf8' }}>Stripe's Privacy Policy</a> and are limited to the payment flow.</p>
        </Section>

        <Section title="4. Managing Your Data">
          <p>Since we use localStorage rather than cookies, standard browser cookie controls do not apply. You can clear your locally stored data at any time by:</p>
          <ul>
            <li>Logging out of your eazyproject account — this clears all session data immediately.</li>
            <li>Clearing your browser's site data from your browser settings.</li>
          </ul>
        </Section>

        <Section title="5. Changes to This Policy">
          <p>We may update this policy if we introduce new features that affect how data is stored locally. Any changes will be reflected on this page with an updated date.</p>
        </Section>

        <Section title="6. Contact">
          <p>If you have any questions about how we handle data storage, please contact us at <a href="mailto:noreply@eazyproject.cloud" style={{ color: '#818cf8' }}>noreply@eazyproject.cloud</a>.</p>
        </Section>

        <div style={{ marginTop: 56, paddingTop: 32, borderTop: '1px solid rgba(255,255,255,0.08)', textAlign: 'center' }}>
          <p style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13, margin: '0 0 12px' }}>© {new Date().getFullYear()} eazyproject</p>
          <a href="/privacy" style={{ color: '#818cf8', fontSize: 13, textDecoration: 'none' }}>Privacy Policy →</a>
        </div>

      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 40 }}>
      <h2 style={{ fontSize: 18, fontWeight: 600, color: 'white', margin: '0 0 14px', paddingBottom: 10, borderBottom: '1px solid rgba(255,255,255,0.07)' }}>{title}</h2>
      <div style={{ fontSize: 15, lineHeight: 1.8, color: 'rgba(255,255,255,0.7)' }}>
        {children}
      </div>
    </div>
  );
}
